// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC, useMemo, useState, useEffect} from "react";
// eslint-disable-next-line node/no-missing-import
import { useLocation, useNavigate } from "react-router-dom";
import usePortal from "react-useportal";
// antd:
import { Switch, Radio, Dropdown, Button, Modal, Typography } from "antd";
// antd-types:
import type { MenuProps } from "antd";
// import type { SizeType } from 'antd/es/config-provider/SizeContext';

// Components:
import DivE from "./DivE.tsx";
import MainMenuContent from "./MainMenuContent.tsx";

// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";

// Reducers:
import {
  getDict, getTheme, getCompact, getLng, getDesktopType, getUser, onChangeTheme, onChangeCompact, onChangeLng, onChangeShowDesktopIconsTitle,
  getUserMenuApps, getAllApps, getAppsState, changeAppState, getDesktopFixed, setDesktopFixed, getSafePtr
} from "../../libs/reducer.ts"; // getConfig

import fnc from "../../libs/fnc.ts";
import AppIcons from "./AppIcons.tsx";

const { rz } = window;

const { Text, Link } = Typography;

type componentProps = {pageTitle?:string | React.ReactNode, pageIcon?: React.ReactNode, toolbarRef?: React.RefObject<null>};

type appToolbarButtonsType = {
  appkey:string,
  hasUndoRedo:boolean,
  undo:{enabled:boolean, action?:(apkey:string) => void},
  redo:{enabled:boolean, action?:(apkey:string) => void},
  hasGPT:boolean,
  chatGPT:{disabled:boolean, tooltip:string, action?:(appkey:string) => void},
  hasVoiceRecorder:boolean,
  voiceRecorder:{disabled:boolean, tooltip:string, action?:(appkey:string) => void}
};

const LayoutMainToolbar:FC<componentProps> = ({pageTitle, pageIcon}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const dct = useAppSelector(getDict);
  const lng = useAppSelector(getLng);
  const theme = useAppSelector(getTheme);
  const appCompact = useAppSelector(getCompact);
  const isMobile = useAppSelector(getDesktopType);
  const allApps = useAppSelector(getAllApps);
  const userMenuApps = useAppSelector(getUserMenuApps);
  const user = useAppSelector(getUser);
  const appsState = useAppSelector(getAppsState);
  const isDesktopFixed = useAppSelector(getDesktopFixed);
  const isSafePtr = useAppSelector(getSafePtr);

  // useEffect(() => { console.log("MainToolbar", {isDesktopFixed}) }, [isDesktopFixed]);
  // useEffect(() => { console.log({userMenuApps}); }, [userMenuApps]);

  // @ts-ignore
  let username = "???"; if (user && (user.name || user.name_ru || user.name_en)) { username = rz.strFromSelectedLng({lng, def: user.name, en: user.name_en, ru: user.name_ru}) };

  /* const isGPTactive = useMemo(() => {
    const gptactive = cfg.chatgpt?.enabled && Boolean(cfg.chatgpt?.token) && Boolean(cfg.chatgpt?.proxyaddress);
    return gptactive;
  }, [cfg.chatgpt?.enabled, cfg.chatgpt?.token, cfg.chatgpt?.proxyaddress]); */

  const LngSwitcher = useMemo<React.ReactElement>(() => ( // props:{tooltip?:string}
    <Radio.Group name="changelng" size="small" value={lng} className="rz-margin-left-right-5 uk-float-center">
      <Radio.Button name="lngen" value="en" onClick={() => dispatch(onChangeLng("en"))}>EN</Radio.Button>
      <Radio.Button name="lngru" value="ru" onClick={() => dispatch(onChangeLng("ru"))}>RU</Radio.Button>
      <Radio.Button name="lngtr" value="tr" onClick={() => dispatch(onChangeLng("tr"))}>TR</Radio.Button>
    </Radio.Group>
  ), [dispatch, lng]);
  const ThemeSwitcher = useMemo<React.ReactElement>(() => (
    <Switch className="rz-margin-left-right-5 uk-float-center"
      checkedChildren={<i className="fa fa-moon-o" />}
      unCheckedChildren={<i className="fa fa-sun-o" />}
      checked={theme === "dark"}
      onChange={(e) => dispatch(onChangeTheme(e))}
    />
  ), [dispatch, theme]);
  const CompactSwitcher = useMemo<React.ReactElement>(() => (
    <Switch className="rz-margin-left-right-5 uk-float-center"
      checkedChildren={<i className="fa fa-search-minus" />}
      unCheckedChildren={<i className="fa fa-search-plus" />}
      checked={appCompact}
      onChange={(e) => dispatch(onChangeCompact(e))}
    />
  ), [appCompact, dispatch]);

  const userMenuItems = useMemo<MenuProps["items"]>(() => { // Array<{key:string, label:React.ReactElement}>
    const usm:MenuProps["items"] = [];
    (userMenuApps || []).forEach((app) => {
      usm.push({
        key: app.key, label: (
          <DivE uk-tooltip={"title:" + (app["title_" + lng] || app.title || "") + ";pos:left;offset:20"}
            onClick={() => { navigate(app.link || "/app") }} // {state: {from: window.location.pathname}, replace: true}
          >
            <AppIcons icopath={app.icon} attrs={{}} />
            &nbsp;{app.key === "usersettings" ? username : (app["title_" + lng] || app.title || "")}
          </DivE>
        )
      });
    });

    dct.p.usermenu.forEach((mm) => {
      if (mm.key === "changelng") {
        usm.push({ key: mm.key, label: (<DivE className="uk-text-center uk-flex uk-flex-center rz-width-1-1" uk-tooltip={"title:" + mm.label + ";pos:left;offset:20"}>{LngSwitcher}</DivE>) });
      }
      else if (mm.key === "changetheme") {
        usm.push({ key: mm.key, label: (<DivE className="uk-text-center uk-flex uk-flex-center rz-width-1-1" uk-tooltip={"title:" + mm.label + ";pos:left;offset:20"}>{ThemeSwitcher}</DivE>) });
      }
      else if (mm.key === "changecompact") {
        usm.push({ key: mm.key, label: (<DivE className="uk-text-center uk-flex uk-flex-center rz-width-1-1" uk-tooltip={"title:" + mm.label + ";pos:left;offset:20"}>{CompactSwitcher}</DivE>) });
      }
      else if (mm.key === "about" && !isSafePtr) {
        usm.push({ key: mm.key, label: (<DivE className="uk-text-center" uk-tooltip={"title:" + mm.label + ";pos:left;offset:20"}><AppIcons icopath="fc/FcAbout" attrs={{}} />&nbsp;{mm.label}</DivE>) });
      }
      else if (mm.key === "exit") {
        usm.push({ key: mm.key, label: (<DivE className="uk-text-center" uk-tooltip={"title:" + mm.label + ";pos:left;offset:25"}><AppIcons icopath="ai/AiOutlineLogout" attrs={{}} />&nbsp;{mm.label}</DivE>) });
      }
      else if (!isSafePtr) {
        usm.push({key: mm.key, label: (<DivE uk-tooltip={"title:" + mm.label + ";pos:left;offset:20"}>&nbsp;&nbsp;{mm.label}</DivE>)});
      }
    });

    return usm;
  }, [CompactSwitcher, LngSwitcher, ThemeSwitcher, dct.p.usermenu, lng, navigate, userMenuApps, username, isSafePtr]);

  const userMenuOnClick = ({key}) => {
    if (key === "about") {
      Modal.info({
        title: dct.p.homepageTitle,
        content: (
          <div>
            <Text type="success">{dct.p.programVersion + fnc.config.version}</Text><br />
            <Link href="mailto:shpalich@gmail.com" target="_blank">© Pavel Tyagaev</Link>
          </div>
        )
      });
    }
    else if (key === "exit") { fnc.userExit() }
  };

  const [openMainMenu, closeMainMenu, isOpenMainMenu, MainMenu] = usePortal({closeOnOutsideClick: true, closeOnEsc: true});

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const homeButtonClick = (e:React.SyntheticEvent) => {
    if (location.pathname !== "/app") navigate("/app"); // {state: {from: location.pathname}}
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const backButtonClick = (e:React.SyntheticEvent) => {
    navigate(-1);
    // navigate(location.state.from, {state: {from: location.pathname}});
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const forwardButtonClick = (e:React.SyntheticEvent) => {
    navigate(+1);
    // navigate(location.state.from, {state: {from: location.pathname}});
  };

  // Undo/Redo and ChatGPT buttons
  const {appkey, hasUndoRedo, undo, redo, hasGPT, chatGPT, hasVoiceRecorder, voiceRecorder} = useMemo<appToolbarButtonsType>(() => {
    const ans:appToolbarButtonsType = {
      appkey: "", hasUndoRedo: false, undo: {enabled: false, action: undefined}, redo: {enabled: false, action: undefined},
      hasGPT: false, chatGPT: {disabled: false, tooltip: "", action: undefined},
      hasVoiceRecorder: false, voiceRecorder: {disabled: false, tooltip: "", action: undefined}
    };
    const curApp = (allApps || []).find((aa) => (aa.link === document.location.pathname)); if (!curApp) { return ans }
    ans.appkey = curApp.key;
    const curState = appsState[curApp.key];

    if (!curState || !curState.mainToolbar || !curState.mainToolbar.specialParams) { return ans }
    ans.hasUndoRedo = Boolean(curState.mainToolbar.specialParams.undo);
    ans.hasGPT = Boolean(curState.mainToolbar.specialParams.chatGPT);
    ans.hasVoiceRecorder = Boolean(curState.mainToolbar.specialParams.voiceRecorder);

    if (ans.hasUndoRedo) {
      ans.undo.enabled = Boolean(curState.mainToolbar.specialParams?.undo?.enabled);
      if (window[curApp.key].undo) {
        if (rz.isPromise(window[curApp.key].undo)) {
          ans.undo.action = (apkey) => {
            window[apkey].undo({appkey: apkey, key: "undo", user, lng, dct}).then((ret) => {
              if (rz.isUndefinedOrNull(ret)) { return }
              if (ret && ret.err) { console.log(ret.err) }
              if (ret && ret?.state?.fullPath && ret?.state?.newState) {
                dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
              }
              if (ret && ret?.globalState) {
                if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
              }
              if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
            });
          };
        }
        else if (rz.isFunction(window[curApp.key].undo)) {
          ans.undo.action = (apkey) => {
            const ret = window[apkey].undo({appkey: apkey, key: "undo", user, lng, dct}); if (rz.isUndefinedOrNull(ret)) { return }
            if (ret && ret.err) { console.log(ret.err) }
            if (ret && ret?.state?.fullPath && ret?.state?.newState) {
              dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
            }
            if (ret && ret?.globalState) {
              if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
            }
            if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
          };
        }
      }
      else {
        ans.undo.action = () => { console.log("undo()") }
      }

      ans.redo.enabled = Boolean(curState.mainToolbar.specialParams?.redo?.enabled);
      if (window[curApp.key].redo) {
        if (rz.isPromise(window[curApp.key].redo)) {
          ans.redo.action = (apkey) => {
            window[apkey].redo({appkey: apkey, key: "redo", user, lng, dct}).then((ret) => {
              if (rz.isUndefinedOrNull(ret)) { return }
              if (ret && ret.err) { console.log(ret.err) }
              if (ret && ret?.state?.fullPath && ret?.state?.newState) {
                dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
              }
              if (ret && ret?.globalState) {
                if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
              }
              if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
            });
          };
        }
        else if (rz.isFunction(window[curApp.key].redo)) {
          ans.redo.action = (apkey) => {
            const ret = window[apkey].redo({appkey: apkey, key: "redo", user, lng, dct}); if (rz.isUndefinedOrNull(ret)) { return }
            if (ret && ret.err) { console.log(ret.err) }
            if (ret && ret?.state?.fullPath && ret?.state?.newState) {
              dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
            }
            if (ret && ret?.globalState) {
              if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
            }
            if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
          };
        }
      }
      else {
        ans.redo.action = () => { console.log("redo()") }
      }
    }

    if (ans.hasGPT) {
      // chatGPT: {disabled: false, tooltip: "", action: undefined}
      ans.chatGPT.disabled = Boolean(curState.mainToolbar.specialParams?.chatGPT?.disabled);
      ans.chatGPT.tooltip = curState.mainToolbar.specialParams?.chatGPT?.tooltip || "";

      if (window[curApp.key].chatGPT) {
        if (rz.isPromise(window[curApp.key].chatGPT)) {
          ans.chatGPT.action = (apkey) => {
            window[apkey].chatGPT({appkey: apkey, key: "chatGPT", user, lng, dct}).then((ret) => {
              if (rz.isUndefinedOrNull(ret)) { return }
              if (ret && ret.err) { console.log(ret.err) }
              if (ret && ret?.state?.fullPath && ret?.state?.newState) {
                dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
              }
              if (ret && ret?.globalState) {
                if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
              }
              if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
            });
          };
        }
        else if (rz.isFunction(window[curApp.key].chatGPT)) {
          ans.chatGPT.action = (apkey) => {
            const ret = window[apkey].chatGPT({appkey: apkey, key: "chatGPT", user, lng, dct}); if (rz.isUndefinedOrNull(ret)) { return }
            if (ret && ret.err) { console.log(ret.err) }
            if (ret && ret?.state?.fullPath && ret?.state?.newState) {
              dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
            }
            if (ret && ret?.globalState) {
              if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
            }
            if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
          };
        }
      }
      else {
        ans.chatGPT.action = () => { console.log("chatGPT()") }
      }
    }

    if (ans.hasVoiceRecorder) {
      // voiceRecorder: {disabled: false, tooltip: "", action: undefined}
      ans.voiceRecorder.disabled = Boolean(curState.mainToolbar.specialParams?.voiceRecorder?.disabled);
      ans.voiceRecorder.tooltip = curState.mainToolbar.specialParams?.voiceRecorder?.tooltip || "";

      if (window[curApp.key].voiceRecorder) {
        if (rz.isPromise(window[curApp.key].voiceRecorder)) {
          ans.voiceRecorder.action = (apkey) => {
            window[apkey].voiceRecorder({appkey: apkey, key: "voiceRecorder", user, lng, dct}).then((ret) => {
              if (rz.isUndefinedOrNull(ret)) { return }
              if (ret && ret.err) { console.log(ret.err) }
              if (ret && ret?.state?.fullPath && ret?.state?.newState) {
                dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
              }
              if (ret && ret?.globalState) {
                if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
                if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
              }
              if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
            });
          };
        }
        else if (rz.isFunction(window[curApp.key].voiceRecorder)) {
          ans.voiceRecorder.action = (apkey) => {
            const ret = window[apkey].voiceRecorder({appkey: apkey, key: "voiceRecorder", user, lng, dct}); if (rz.isUndefinedOrNull(ret)) { return }
            if (ret && ret.err) { console.log(ret.err) }
            if (ret && ret?.state?.fullPath && ret?.state?.newState) {
              dispatch(changeAppState({appkey: apkey, fullPath: ret.state.fullPath, newState: ret.state.newState}));
            }
            if (ret && ret?.globalState) {
              if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
              if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
            }
            if (ret && ret.navigate) { navigate(ret.navigate.to, {replace: Boolean(ret.navigate.replace)}) }
          };
        }
      }
      else {
        ans.voiceRecorder.action = () => { console.log("voiceRecorder()") }
      }
    }
    return ans;
  }, [allApps, appsState, dct, dispatch, lng, navigate, user]);

  return (
    <DivE key="layout-main-toolbar" id="layout-main-toolbar" className="uk-position-top uk-margin-remove" appkey={appkey}>
      <nav key="layout-mainmenu-nav" id="layout-mainmenu-nav" className="uk-navbar uk-navbar-container uk-margin-remove uk-flex uk-flex-row uk-flex-nowrap rz-padding-5 rz-theme-d4 rz-border-bottom-d2">
        <div key="uk-navbar-left" className="uk-navbar-left rz-width-expand">
          <div key="div-button-mainmenu" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
            <Button type="primary" size={isMobile ? undefined : "large"} icon={<AppIcons icopath="cg/CgMenu" attrs={{}} />} onClick={(e) => { openMainMenu(e) }} uk-tooltip={dct.p.mainmenutitle} />
          </div>
          {(window.history.length) ? ( // location.state && location.state.from
            <div key="div-button-back" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
              <Button size={isMobile ? undefined : "large"} icon={<AppIcons icopath="md/MdArrowBack" attrs={{}} />} onClick={(e) => { backButtonClick(e) } } uk-tooltip={dct.p.back}
                disabled={window.history.length < 3 || !window.history?.state?.idx}
              />
            </div>
          ) : undefined}
          {(window.history.length) ? (
            <div key="div-button-forward" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
              <Button size={isMobile ? undefined : "large"} icon={<AppIcons icopath="md/MdArrowForward" attrs={{}} />} onClick={(e) => { forwardButtonClick(e) } } uk-tooltip={dct.p.forward}
                disabled={window.history?.state?.idx >= (window.history.length - 2)}
              />
            </div>
          ) : undefined}
          {(location.pathname !== "/app") ? (
            <div key="div-button-home" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
              <Button size={isMobile ? undefined : "large"} icon={<AppIcons icopath="ai/AiOutlineHome" attrs={{}} />} onClick={(e) => { homeButtonClick(e) } } uk-tooltip={dct.p.homebuttontitle} />
            </div>
          ) : undefined}
          {hasUndoRedo ? (
            <React.Fragment key="fragment-undo-redo" >
              <div key="div-button-undo" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
                <Button key="button-undo" className={undo.enabled ? "" : "uk-disabled"} disabled={!undo.enabled} size={isMobile ? undefined : "large"}
                  icon={<AppIcons icopath="fa/FaUndo" attrs={{}} />} onClick={() => { if (undo.action) { undo.action(appkey) } } } uk-tooltip={dct.p.undo}
                />
              </div>
              <div key="div-button-redo" className="uk-navbar-item uk-padding-remove rz-padding-left-5">
                <Button key="button-redo" className={redo.enabled ? "" : "uk-disabled"} disabled={!redo.enabled} size={isMobile ? undefined : "large"}
                  icon={<AppIcons icopath="fa/FaRedo" attrs={{}} />} onClick={() => { if (redo.action) { redo.action(appkey) } } } uk-tooltip={dct.p.redo}
                />
              </div>
            </React.Fragment>
          ) : undefined}
          <div key="current-app-title" className="uk-navbar-item rz-padding-left-10 rz-padding-right-5 rz-width-expand uk-flex uk-flex-row uk-flex-center uk-flex-nowrap uk-text-center">
            <span className="uk-text-lead rz-txt-light uk-flex uk-flex-middle">{pageIcon || ""}</span>
            <span className="rz-hidden@lg uk-text-lead rz-txt-light rz-margin-left-10">{pageTitle || ""}</span>
          </div>
        </div>

        <div key="uk-navbar-right" className="uk-navbar-right">
          {
            location?.pathname === "/app" && (
              <div key="button-fix-icons" className="uk-navbar-item uk-padding-remove rz-padding-right-5">
                <Button
                  icon={isDesktopFixed ? <AppIcons icopath="ri/RiPushpinLine" attrs={{}} /> : <AppIcons icopath="ri/RiUnpinLine" attrs={{}} />}
                  size={isMobile ? undefined : "large"}
                  uk-tooltip={{
                    ru: (isDesktopFixed ? "Местоположение приложений на рабочем столе зафиксировано" : "Приложения на рабочем столе можно перемещать"),
                    en: (isDesktopFixed ? "The desktop applications location is fixed" : "Applications on the desktop can be moved"),
                    tr: (isDesktopFixed ? "Uygulamaların masaüstündeki konumu sabittir" : "Masaüstündeki uygulamalar taşınabilir")
                  }[lng || "en"]}
                  onClick={() => { dispatch(setDesktopFixed(!isDesktopFixed)) }}
                />
              </div>
            )
          }
          {hasVoiceRecorder ? (
            <div key="button-voice-recorder" className="uk-navbar-item uk-padding-remove rz-padding-right-5">
              <Button icon={<AppIcons icopath="md/MdKeyboardVoice" attrs={{}} />} disabled={voiceRecorder.disabled} size={isMobile ? undefined : "large"} uk-tooltip={voiceRecorder.tooltip || ""}
                onClick={() => { if (voiceRecorder.action) { voiceRecorder.action(appkey) } } }
              />
            </div>
          ) : undefined}
          {hasGPT ? (
            <div key="button-ai" className="uk-navbar-item uk-padding-remove rz-padding-right-5">
              <Button icon={<AppIcons icopath="ai/AiOutlineOpenAI" attrs={{}} />} disabled={chatGPT.disabled} className={!chatGPT.disabled ? "glow-on-hover" : ""} size={isMobile ? undefined : "large"} uk-tooltip={chatGPT.tooltip || "ChatGPT"}
                onClick={() => { if (chatGPT.action) { chatGPT.action(appkey) } } }
              />
            </div>
          ) : undefined}
          <div key="button-user-menu" className="uk-navbar-item uk-padding-remove rz-padding-right-5">
              {(
                user && user.login
                  ? <Dropdown menu={{items: userMenuItems, onClick: userMenuOnClick}}
                      trigger={["click"]} placement="bottom" overlayStyle={{minWidth: "300px", maxWidth: "500px"}}
                    >
                    <Button icon={<AppIcons icopath="fa/FaUserCheck" attrs={{}} />} size={isMobile ? undefined : "large"} uk-tooltip={username} />
                  </Dropdown>
                  : <div />
              )}
          </div>
        </div>
      </nav>
      {
        isOpenMainMenu && <MainMenu>
          <MainMenuContent closePortal={closeMainMenu} />
        </MainMenu>
      }
    </DivE>
  );
};

export default LayoutMainToolbar;
